import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { Description1f0zycfwk0zld as Description } from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { PrimitiveDescriptorWithAnnotations1b27un5ddu1g9 as PrimitiveDescriptorWithAnnotations } from './SerializationHelpers.mjs';
import { DataClassPathSerializer2aqs8pcwb13zn as DataClassPathSerializer } from './DataClassPathSerializer.mjs';
import {
  DataClassPathSelf18kqeagzkbefr as DataClassPathSelf,
  DataClassPathAccess3qupo9g6dhbeb as DataClassPathAccess,
} from './DataClassPath.mjs';
import { get_serializableProperties1162nosnaangd as get_serializableProperties } from './SerializableProperty.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { first1vi3grnpj1175 as first } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { SortParte7ewatwctfe4 as SortPart } from './SortPart.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  startsWith1bgirhbedtv2y as startsWith,
  removePrefix279df90bhrqqg as removePrefix,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KSerializerWithDefault3c244bl47fg5p as KSerializerWithDefault } from './Defaults.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SortPartSerializerClass;
function SortPartSerializer() {
  if (SortPartSerializerClass === VOID) {
    class $ {
      constructor(inner) {
        this.inner_1 = inner;
        this.descriptor_1 = new (PrimitiveDescriptorWithAnnotations())('com.lightningkite.services.database.SortPart', STRING_getInstance(), listOf(new (Description())("The name of the property to sort by.  Prepend a '-' if you wish to sort descending.  Prepend '~' if you wish to ignore case.")));
        this.sub_1 = new (DataClassPathSerializer())(this.inner_1);
      }
      get_default_qtagd4_k$() {
        return new (SortPart())(new (DataClassPathAccess())(new (DataClassPathSelf())(this.inner_1), first(ensureNotNull(get_serializableProperties(this.inner_1)))));
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      deserialize_sy6x50_k$(decoder) {
        var value = decoder.decodeString_x3hxsx_k$();
        var descending = startsWith(value, _Char___init__impl__6a9atx(45));
        var nameWithoutCase = removePrefix(value, '-');
        var ignoreCase = startsWith(nameWithoutCase, _Char___init__impl__6a9atx(126));
        var name = removePrefix(nameWithoutCase, '~');
        return new (SortPart())(this.sub_1.fromString_g5hge7_k$(name), !descending, ignoreCase);
      }
      serialize_nyit6f_k$(encoder, value) {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        if (!value.ascending_1) {
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(45));
        }
        if (value.ignoreCase_1) {
          this_0.append_58al37_k$(_Char___init__impl__6a9atx(126));
        }
        this_0.append_22ad7x_k$(value.field_1.toString());
        var tmp$ret$0 = this_0.toString();
        encoder.encodeString_424b5v_k$(tmp$ret$0);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_nyit6f_k$(encoder, value instanceof SortPart() ? value : THROW_CCE());
      }
    }
    initMetadataForClass($, 'SortPartSerializer', VOID, VOID, [KSerializerWithDefault()]);
    SortPartSerializerClass = $;
  }
  return SortPartSerializerClass;
}
//region block: exports
export {
  SortPartSerializer as SortPartSerializerr929bckmbnab,
};
//endregion

//# sourceMappingURL=SortPartSerializer.mjs.map
